import React, { FC } from "react";
import styled, { css, themeGet } from "../../styles";
import { Tabs } from "react-tabs";

export const StyledAddTabContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const StyledAProgramContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const StyledAdvText = styled.div`
  display: flex;
  flex-direction: initial;
  align-items: center;
`;

export const StyledTitleAD = styled.p`
  font-size: medium;
  font-weight: 600;
  padding-right: 5px !important;
  margin-bottom: 0px !important;
`;

export const StyledText = styled.p``;

export const TagsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;
